import { configureStore } from "@reduxjs/toolkit";
import { activityLogSlice } from "./ActivityLogSlice";

export const store = configureStore({
  reducer: {
    activityLog: activityLogSlice.reducer,
  },
});
